import React from "react";
import { TrendingUp, TrendingDown } from "lucide-react";
import { formatMoney, formatNumber } from "@/lib/format";

export default function KpiCard({ kpi, currency, index = 0 }) {
  const isMoney = kpi.value_cents !== undefined;
  const value = isMoney ? formatMoney(kpi.value_cents, currency) : formatNumber(kpi.value);
  const trend = kpi.trend;
  // For expenses, a decrease is good (invert color logic).
  const good = trend == null ? null : kpi.invert_trend ? trend <= 0 : trend >= 0;

  return (
    <div
      data-testid={`kpi-${kpi.id}-card`}
      className="animate-fade-up rounded-xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_3px_0_rgba(15,23,42,0.04)] transition-all hover:border-slate-300"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <p className="text-xs font-medium uppercase tracking-wider text-slate-500">{kpi.title}</p>
      <p data-testid={`kpi-${kpi.id}-value`} className="mt-2 font-mono text-2xl font-bold tracking-tight text-slate-900 sm:text-3xl">
        {value}
      </p>
      <div className="mt-2 flex items-center gap-1.5">
        {trend != null && (
          <span className={`inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 text-xs font-semibold ${good ? "bg-emerald-50 text-emerald-700" : "bg-rose-50 text-rose-700"}`}>
            {good ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
            {trend > 0 ? "+" : ""}{trend}%
          </span>
        )}
        <span className="truncate text-xs text-slate-400">
          {kpi.margin !== undefined ? `Marge ${kpi.margin}%` : kpi.sub || "vs période précédente"}
        </span>
      </div>
    </div>
  );
}
